export const catTipoPago = Object.freeze({
    NOAPLICA: 0,
    PLAN_PAGOS: 1,
    TARJETA_CREDITO: 2,
    HIBRIDO: 3,
    EXTRA: 5,
})